'use client';

import Script from 'next/script';
import { getConfig } from '@/utils/config/config';

export const OsanoScript = () => {
    const config = getConfig();
    const osano = config?.services?.osano;

    if (!osano?.customerId || !osano?.configId) {
        return null;
    }

    const src = `https://cmp.osano.com/${osano.customerId}/${osano.configId}/osano.js`;
    return <Script src={src} strategy="afterInteractive" />;
};
